module.exports = __webpack_public_path__ + "img/no_syn.b3e35872.svg";